import get from 'lodash/get';
import { createSelector } from 'reselect';
import { selectFromConfig } from '@gandi/redux-config';
import sharingResource from './resource';
export const selectSharing = state => state.sharing;
export const selectCurrentId = createSelector(selectSharing, sharing => sharing && sharing.current || '');
export const selectCurrent = createSelector(selectSharing, selectCurrentId, (sharing, id) => get(sharing, ['organizations', id]));
export const selectPersonalId = createSelector(selectSharing, sharing => sharing && sharing.personal || '');
export const selectPersonal = createSelector(selectSharing, selectPersonalId, (sharing, id) => get(sharing, ['organizations', id]));
export const selectOrganizations = createSelector(selectPersonalId, selectSharing, (id, sharing) => Object.keys(sharing.organizations).filter(key => key !== id).map(key => sharing.organizations[key]));
export const selectFilteredOrganizations = createSelector(selectSharing, sharing => Object.keys(sharing.filteredOrganizations).map(key => sharing.filteredOrganizations[key]));
export const selectOrganizationsFetching = (state, label) => sharingResource.selectIsFetching(state, label || 'default');
export const selectOrganizationsLoaded = (state, label) => sharingResource.selectIsLoaded(state, label || 'default');
export const selectOneOrganization = createSelector(selectSharing, (_, props) => props, (sharing, props) => sharing.organizations?.[props.id]);
export const selectOneOrganizationFetching = (state, id) => sharingResource.selectIsFetchingOne(state, {
  label: id
});
export const selectOneOrganizationLoaded = (state, id) => sharingResource.selectIsLoadedOne(state, {
  label: id
});
export const selectSettingsUrl = createSelector(selectFromConfig('app.layout.urls', {}), selectPersonalId, (publicUrls, personalId) => {
  if (!personalId) {
    return publicUrls.account;
  }
  return `/organizations/${personalId}/account`;
});
export const selectManageOrganizationsUrl = createSelector(selectFromConfig('app.layout.urls', {}), selectCurrent, (publicUrls, currentOrga) => {
  if (!currentOrga) {
    return '/organizations/organizations';
  }
  return `/organizations/${currentOrga.id}/organizations`;
});